/* eslint-disable @typescript-eslint/no-non-null-assertion */
/*
 * This component COULD be refactored and moved to a shared component library.
 * Therefore, it was implemented separately to facilitate the future changes.
 *
 * @andersonba
 */

import { gql, useLazyQuery } from '@apollo/client'
import { Spinner } from '@farol-ds/react'
import classNames from 'classnames'

import { useProfileFollow } from '../../hooks'
import { PopoverHover } from '../doc-popover'
import {
  ProfileQuickview_ProfileFragment,
  ProfileQuickviewQuery,
} from './__generated__/profile-quickview.graphql'
import styles from './profile-quickview.module.scss'
import { ProfileQuickviewContent } from './profile-quickview-content'

export interface ProfileQuickviewProps {
  profile: ProfileQuickview_ProfileFragment
  getElementNodes: () => HTMLElement[]
}

export function ProfileQuickview(props: ProfileQuickviewProps) {
  const {
    profile: { pid },
    getElementNodes,
  } = props

  const [fetchProfile, { loading, called, data }] = useLazyQuery<ProfileQuickviewQuery>(
    FETCH_PROFILE,
    {
      variables: { pid },
    }
  )
  const isLoading = loading || !called

  const { profile = null } = data?.root || {}

  return (
    <PopoverHover
      getElementNodes={getElementNodes}
      disablePadding
      placement="bottom"
      onOpenChange={(isOpen) => {
        if (isOpen && !loading) {
          fetchProfile()
        }
      }}
      className={classNames(styles.popover, {
        [styles.popoverLoading]: isLoading,
      })}
    >
      {isLoading ? (
        <div className={styles.loading} data-testid="loading">
          <Spinner />
        </div>
      ) : (
        <ProfileQuickviewContent profile={profile} />
      )}
    </PopoverHover>
  )
}

ProfileQuickview.fragments = {
  profile: gql`
    fragment ProfileQuickview_profile on Profile {
      pid
    }
  `,
}

export const FETCH_PROFILE = gql`
  query ProfileQuickview($pid: Int!) {
    root {
      profile(pid: $pid) {
        id
        fullname
        url
        followingAmount
        followersAmount
        isLawyer
        profileType
        isVerified
        isInstitutional
        hasProBadge
        cover: thumborCoverImage {
          url: thumbUrl(size: "320x112")
        }
        avatar: thumborAvatar {
          url2xl: thumbUrl(size: "96x96")
        }
        occupation {
          title
        }
        homeLocation {
          title
        }

        ...UseProfileFollow_profile
      }
    }
  }

  ${useProfileFollow.fragments.profile}
`
